<template>
  <div class="column is-12 is-paddingless">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('catalogue.newProduct.produitAchatLie.title') }}
        </p>
      </header>
      <div class="card-content">
        <div class="columns">
        <b-field :label="$t('catalogue.newProduct.produitAchatLie.produit.title')"
                 class="column is-11">
          <b-autocomplete :open-on-focus="true"
                          icon="magnify"
                          :data="autoCompleteData"
                          v-model="search"
                          :loading="isFetching"
                          field="libelleAutocomplete"
                          @input="getProduitAchatLie"
                          :placeholder="$t('catalogue.newProduct.produitAchatLie.produit.search')"
                          @select="item => selectProduit(item)">
          </b-autocomplete>
        </b-field>
        <a class="column is-1 mgt-35px" @click="deleteProduitOpposeLie()">
          <b-icon  icon="delete-forever"
                   type="is-danger">
          </b-icon>
        </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce';
import { getAll as getAllProduitDivers } from '@/api/produit/produitDivers';
import { getAll as getAllProduitLocation } from '@/api/produit/produitLocation';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';
import { cloneDeep } from 'lodash';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'produitAchatLie',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: null,
      autoCompleteData: [],
      compteAnalytiqueToAdd: null,
      produitAchatLieSearch: null,
      isFetching: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    selectProduit(produitSelect) {
      if (!produitSelect) return;
      this.search = cloneDeep(produitSelect.libelle);
      this.produit.produitOpposeLieId = produitSelect.id;
    },
    modificationAutoComplete(produits) {
      this.autoCompleteData = [];
      produits.forEach((produit) => {
        produit.libelleAutocomplete = produit.libelle + ' - ' + produit.reference;
        this.autoCompleteData.push(produit);
      });
    },
    deleteProduitOpposeLie() {
      this.search = '';
      this.produit.produitOpposeLieId = null;
      this.produit.produitOppose = null;
    },
    getProduitAchatLie: debounce(async function loadData() {
      this.isFetching = true;
      try {
        if (this.search.length === 0) {
          this.isFetching = false;
          return;
        }
        const parameter = {
          query: {
            auto: this.search,
            sens: this.produit.sens === SENS_ACHAT ? SENS_VENTE : SENS_ACHAT,
            societeId: this.societeActiveId,
          },
        };
        let produits = [];
        if (this.produit.produitDivers || this.produit.produitDispositif) {
          produits = (await getAllProduitDivers(parameter)).data.result.items;
        } else if (this.produit.produitLocation) {
          produits = (await getAllProduitLocation(parameter)).data.result.items;
        }
        this.modificationAutoComplete(produits);
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw (e);
      }
    }, 500),
  },
  mounted() {
    if (this.produit.produitOpposeLieId) {
      this.search = this.produit.produitOpposeLie.libelle + ' - ' + this.produit.produitOpposeLie.reference;
    }
  },
};
</script>

<style scoped>

</style>
